"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _lodash = require("lodash");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    button: {
      margin: theme.spacing.unit
    },
    textField: {
      marginTop: '1rem',
      fontSize: 12
    },
    dialogPaper: {
      minWidth: '20rem',
      minHeight: '30rem'
    }
  };
};
var languages = [{
  label: 'French',
  value: 'French'
}, {
  label: 'Spanish',
  value: 'Spanish'
}, {
  label: 'German',
  value: 'German'
}, {
  label: 'Turkish',
  value: 'Turkish'
}, {
  label: 'Italian',
  value: 'Italian'
}, {
  label: 'Portuguese',
  value: 'Portuguese'
}, {
  label: 'Polish',
  value: 'Polish'
}, {
  label: 'British English',
  value: 'British English'
}, {
  label: 'Japanese',
  value: 'Japanese'
}, {
  label: 'Indonesian',
  value: 'Indonesian'
}, {
  label: 'Chinese',
  value: 'Chinese'
}, {
  label: 'Korean',
  value: 'Korean'
}];
var MatrixQuestionTranslation = /*#__PURE__*/function (_Component) {
  function MatrixQuestionTranslation(props) {
    var _question$translation;
    var _this;
    (0, _classCallCheck2["default"])(this, MatrixQuestionTranslation);
    _this = _callSuper(this, MatrixQuestionTranslation, [props]);
    var question = props.question;
    _this.state = {
      translations: (_question$translation = question === null || question === void 0 ? void 0 : question.translations) !== null && _question$translation !== void 0 ? _question$translation : {},
      selectedLanguage: '',
      questionDescription: ''
    };
    ['handleSelectChange', 'handleInputChange', 'onClose'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(MatrixQuestionTranslation, _Component);
  return (0, _createClass2["default"])(MatrixQuestionTranslation, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
      var _this$state = this.state,
        translations = _this$state.translations,
        selectedLanguage = _this$state.selectedLanguage;
      this.setState((0, _defineProperty2["default"])({}, name, value), function () {
        if (translations[selectedLanguage.value] === undefined) {
          translations[selectedLanguage.value] = {};
        }
        translations[selectedLanguage.value] = value;
      });
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange(value) {
      var _this$state2 = this.state,
        translations = _this$state2.translations,
        selectedLanguage = _this$state2.selectedLanguage;
      this.setState({
        selectedLanguage: value
      });
      if (value.value) {
        if (translations[value.value] === undefined) {
          translations[value.value] = {};
        }
        this.setState({
          questionDescription: translations[value.value] ? translations[value.value] : ''
        });
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        questionDescription: '',
        selectedLanguage: ''
      });
      this.props.onClose();
    }
  }, {
    key: "onConfirm",
    value: function onConfirm() {
      var question = this.props.question;
      question.translations = this.state.translations;
      this.props.onConfirm(question);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        onClose = _this$props.onClose,
        onConfirm = _this$props.onConfirm,
        open = _this$props.open;
      var _this$state3 = this.state,
        selectedLanguage = _this$state3.selectedLanguage,
        questionDescription = _this$state3.questionDescription;
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
        classes: {
          paper: classes.dialogPaper
        },
        onClose: this.onClose,
        "aria-labelledby": "simple-dialog-title",
        open: open,
        maxWidth: "lg",
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
        id: "simple-dialog-title"
      }, "Translations"), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
        onChange: this.handleSelectChange,
        value: selectedLanguage,
        name: "language_select",
        options: [].concat(languages),
        placeholder: "Select a Language"
      }), /*#__PURE__*/_react["default"].createElement("br", null), this.state.selectedLanguage && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, "Question Description"), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        label: "",
        name: "questionDescription",
        onChange: this.handleInputChange,
        value: questionDescription,
        fullWidth: true,
        multiline: true
      }))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return _this2.onClose();
        }
      }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        form: "theForm",
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return _this2.onConfirm();
        }
      }, "Confirm")));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var _question$translation2;
      var question = props.question;
      var newState = _objectSpread(_objectSpread({}, state), {}, {
        translations: (_question$translation2 = question === null || question === void 0 ? void 0 : question.translations) !== null && _question$translation2 !== void 0 ? _question$translation2 : {}
      });
      if (!(0, _lodash.isEmpty)(question)) {
        Object.keys(question).forEach(function (k) {
          newState[k] = question[k];
        });
      }
      return _objectSpread({}, newState);
    }
  }]);
}(_react.Component);
MatrixQuestionTranslation.propTypes = {
  onConfirm: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  question: _propTypes["default"].object
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(MatrixQuestionTranslation);